import React from 'react'
import { formatDateToCustom } from '../utils/utils'

function OrderHistoryLayoutOne({ordernumber,status,date,amount, onClick }) {
  return (
    <>
    <div className={"order-summery-grid fontclass"} onClick={onClick} style={{cursor:'pointer'}}>
        <p>Order Number : <span>{ordernumber}</span></p>
        <p>Order Status:  <span className={status === 'New' || status === 'Success' ? 'text-success' : 'text-danger'}>{status?.replaceAll('_'," ")}</span></p>
        <p>Order Date : <span>{formatDateToCustom(date)}</span></p>
        <p>Order Amount : <span>{amount.toLocaleString("en-IN")}</span></p>
    </div>
    </>
  )
}

export default OrderHistoryLayoutOne